<template>
  <div>
    <Card :bordered="false" shadow>
      <period-management-setting
        @resetList="period_management_list"
        :modal.sync="settingModal"
        :stateModal="stateModal"
      ></period-management-setting>
      <Row type="flex" align="middle">
        <span>期数管理</span>
        <Button
          type="primary"
          class="mx-1"
          @click="clickModal('1');"
          v-if="getpermission.period[1] == '1'"
        >新增期数</Button>
        <Button
          type="error"
          @click="pdcl(0, getmember.pid)"
          v-if="getpermission.period[2] == '1'"
        >强制关盘</Button>
        <lida-table :propscolumns="columns" :data="tb1" :sortStatus="false"></lida-table>
      </Row>
      <divider />
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "PeriodManagement",
  components: {
    PeriodManagementSetting: () =>
      import(
        /* webpackChunkName: "period_management" */ "./components/PeriodManagementSetting"
      ),
  },
  data () {
    return {
      tb1: [],
      settingModal: false,
      stateModal: {
        state: "1",
        listid: null
      }
    };
  },
  computed: {
    ...mapGetters(["getmember", "getpermission", "getgameid"]),
    operatingState () {
      return this.getpermission.period[2] == '0' && this.getpermission.period[3] == '0'
    },
    columns () {
      return {
        speriod: {
          title: "期数",
          key: "period",
          align: "center"
        },
        date: {
          title: "日期",
          key: "date",
          align: "center"
        },
        opdate: {
          title: "开盘时间",
          key: "opdate",
          align: "center"
        },
        stdate: {
          title: "非特码停押时间",
          key: "stdate",
          align: "center"
        },
        cldate: {
          title: "关盘时间",
          key: "cldate",
          align: "center"
        },
        state: {
          title: "状态",
          key: "state",
          align: "center",
          render: (h, params) => {
            let stateText
            let _class = {}
            switch (params.row.state) {
              case 1:
                stateText = '开盘'
                _class['pc3'] = true
                break;
              case 2:
                stateText = '等待开盘'
                break;
              case 3:
                stateText = '非特码停押'
                break;
              case 0:
                stateText = '关盘'
                _class['pc1'] = true
                break;
              default:
                break;
            }
            return h('p', { class: _class }, stateText)
          }
        },
        id: {
          title: "操作",
          key: "state",
          align: "center",
          width: 240,
          hide: this.operatingState,
          render: (h, params) => {
            let switchButton
            switch (params.row.state) {
              case 1:
                switchButton = h('Button', {
                  props: {
                    size: 'small',
                    type: 'info'
                  },
                  on: {
                    click: () => this.autostopnos(params.row.id)
                  }
                }, '自动停押非特码')
                break;
              case 2:
                switchButton = h('Button', {
                  props: {
                    size: 'small',
                    type: 'info'
                  },
                  on: {
                    click: () => this.autoopen(params.row.id)
                  }
                }, '开盘')
                break;
              case 3:
                switchButton = h('Button', {
                  props: {
                    size: 'small',
                    type: 'success'
                  },
                  on: {
                    click: () => this.pdcl(params.row.id)
                  }
                }, '关盘')
                break;
              default:
                switchButton = null
                break;
            }
            const modifyButton = h('Button', {
              props: {
                size: 'small',
                type: 'warning'
              },
              class: {
                'mx-1': true,
              },
              on: {
                click: () => this.clickModal('2', params.row.id)
              }
            }, '修改')
            const removeButton = h('Button', {
              props: {
                size: 'small',
                type: 'error'
              },
              on: {
                click: () => this.pddpo(params.row.id)
              }
            }, '删除')
            return h('div', [
              this.getpermission.period[2] == '1' ? switchButton : null,
              this.getpermission.period[2] == '1' ? modifyButton : null,
              this.getpermission.period[3] == '1' ? removeButton : null
            ])
          }
        }
      }
    },
  },
  watch: {
    getgameid () {
      this.period_management_list()
    }
  },
  created () {
    this.period_management_list();
  },
  methods: {
    clickModal (state, id) {
      this.settingModal = !this.settingModal;
      this.stateModal.state = state;
      this.stateModal.listid = id;
    },
    // 等待开盘 < 开盘 < 非特码关盘 < 关盘
    // 非特码关盘 关盘 有时是一样的
    async period_management_list () {
      try {
        const res = await this.$axios.periodManagement.list(this.getgameid)
        if ('status' in res && res.status === 0) return
        this.tb1 = res;
      } catch (error) {
        console.error(error)
      }
    },
    autostopnos (id, pid) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认要更改非特码 ?",
        onOk: res => {
          this.$axios.periodManagement
            .autostopnos(this.getgameid, { pid: id, loid: this.getmember.pid })
            .then(res => {
              if (res.status == 1) {
                this.$Message.success("已更改");
                this.period_management_list();
              } else {
                this.period_management_list();
              }
            });
        }
      });
    },
    autoopen (id, pid) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否要开盘 ?",
        onOk: res => {
          this.$axios.periodManagement
            .autoopen(this.getgameid, { pid: id, loid: this.getmember.pid })
            .then(res => {
              if (res.status == 1) {
                this.$Message.success("已开盘");
                this.period_management_list();
              } else {
                this.period_management_list();
              }
            });
        }
      });
    },
    pdcl (pid) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否关盘 ?",
        onOk: res => {
          this.$axios.periodManagement
            .closePeriod(this.getgameid, { pid: pid, loid: this.getmember.pid })
            .then(res => {
              if (res.status == 1) {
                this.$Message.success("已关盘");
                this.period_management_list();
              } else {
                this.period_management_list();
              }
            });
        }
      });
    },
    pddpo (id, pid) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "是否删除该期数 ?",
        onOk: res => {
          this.$axios.periodManagement
            .removePeriod(
              this.getgameid,
              {
                pid: id,
                loid: this.getmember.pid
              }
            )
            .then(res => {
              if (res.status == 1) {
                this.$Message.success("已删除");
                this.period_management_list();
              } else {
                this.period_management_list();
              }
            });
        }
      });
    }
  }
};
</script>
